<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable"  @btnclick="bthClick" :pageData="pageData"></table-page>
    <UPDATE  ref="childUpdate" @uploadResult="uploadResult"  :updateData="updateData"></UPDATE>
  </div>
</template>

<script>
  //table封装组件
  import tablePage from '@/components/page/table.vue'
  import FORM from '@/components/page/form.vue'
  import UPDATE from '@/components/page/update.vue'
  import URL from '@/views/newmis36/util/url'
  import DateUtil from '@/utils/IM/tradeDataUtil.js'
  export default {
    name: 'list',
    components: {
      tablePage,
      FORM,
      UPDATE
    },
    methods: {
      uploadResult(col,res){
        this.$refs.childTable.defaultQueryData(this.queryData);
        if (res.code == 0){
          this.$refs.childUpdate.close();
        }else{
          this.$message.error(res.message);
        }
      },
      /*表格按钮点击事件*/
      bthClick (clickName, row) {
        if (clickName == "update"){
          this.$refs.childUpdate.open(row);
        }
      },
      /*查询表单按钮点击事件*/
      formclick(clickName, data){
        if("查询" == clickName){
          this.queryData = data;
          this.$refs.childTable.defaultQueryData(this.queryData);
        }else if("上传" == clickName){
          this.$refs.childUpdate.open();
        }
      },
    },
    data () {
      return {
        queryData:{},
        /*新增或更新*/
        updateData:{
          submit: "hidden",
          modelName:"上传活动",
          cols:[
            { title: "上传活动事件", field: 'file',type:11,action:URL.tradingActivitiesTime.upload,downUrl:"https://static.chwenda.com/source/downloadModel/%E6%A6%9C%E5%8D%95%E6%B4%BB%E5%8A%A8%E6%97%B6%E9%97%B4%E6%AE%B5.xlsx"},
          ]
        },
        /*from查询表单*/
        formData:{
          hasLable: true,
          cols:[
            {click:"查询"},
            {click:"上传"},
          ]
        },
        /*table生成*/
        pageData: {
          queryUrl: URL.tradingActivitiesTime.list , //请求路径和参数
          sequence: true,
          cols: [
            { title: '日期时间段', field: 'time'},
            { title: '事件（VN）', field: 'activitVn'},
            { title: '事件（EN）', field: 'activitEn'},
            { title: '产品', field: 'symbol'},
            { title: '创建时间', field: 'createTime',render:(data,full)=>{
                return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
              }},
          ]
        }
      }
    }
  }
</script>
